import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class ClientSalesAfterSalesFactory {
    constructor({options, currentMap}){
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const salesTypes = environment.get('CONFIG.FILTERS.SALES_TYPES');

        let data = [];

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_CLIENT_SALES.filterSalesType)) {
            data.push({
                name: 'salesTypes',
                position: 1,
                data: salesTypes,
                fields: [
                    {
                        title: translate('Common.SalesType'),
                        name: 'salesTypes',
                        value: 'id',
                        text: 'nome',
                        type: 'multiselect',
                        skipAll: true
                    }
                ]
            });
        }

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_CLIENT_SALES.filterSalesType) && isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.changeTitleOfChartsAndFilters)) {
            data = [];
            data.push({
                name: 'salesTypes',
                position: 1,
                data: salesTypes,
                fields: [
                    {
                        title: translate('Common.TypeSegmentMarket'),
                        name: 'salesTypes',
                        value: 'id',
                        text: 'nome',
                        type: 'multiselect',
                        skipAll: true
                    }
                ]
            });
        }

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/clientSalesAfterSales.factory.js